// extracted by mini-css-extract-plugin
export var quillEditor = "_p2-1";
export var variable = "_p2-0";